import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
const PasswordAccess = ({ enabled = false, password, children, }) => {
    const [inputValue, setInputValue] = useState('');
    const [hasAccess, setHasAccess] = useState(!enabled);
    const [error, setError] = useState('');
    if (!enabled) {
        return _jsx(_Fragment, { children: children });
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputValue === password) {
            setHasAccess(true);
            setError('');
        }
        else {
            setError('Incorrect password. Please try again.');
        }
    };
    if (hasAccess) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsx("div", Object.assign({ style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            backgroundColor: '#0e0e0e',
            color: '#fff',
        } }, { children: _jsxs("form", Object.assign({ onSubmit: handleSubmit, style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '1rem',
                padding: '2rem',
                borderRadius: '0.75rem',
                border: '1px solid rgba(255, 255, 255, 0.15)',
                backgroundColor: 'rgba(12, 12, 12, 0.85)',
                width: 'min(90vw, 360px)',
            } }, { children: [_jsxs("div", { children: [_jsx("label", Object.assign({ htmlFor: "site-password", style: { display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem' } }, { children: "Enter password to view the site" })), _jsx("input", { id: "site-password", type: "password", value: inputValue, onChange: (event) => {
                                setInputValue(event.target.value);
                                if (error) {
                                    setError('');
                                }
                            }, style: {
                                width: '100%',
                                padding: '0.75rem',
                                borderRadius: '0.5rem',
                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                backgroundColor: 'transparent',
                                color: '#fff',
                            } })] }), error && (_jsx("p", Object.assign({ style: { color: '#ff8080', margin: 0, fontSize: '0.85rem' } }, { children: error }))), _jsx("button", Object.assign({ type: "submit", style: {
                        padding: '0.75rem',
                        borderRadius: '0.5rem',
                        border: 'none',
                        cursor: 'pointer',
                        fontWeight: 600,
                        background: 'linear-gradient(135deg, rgba(209,181,118,0.9), rgba(176,143,78,0.85))',
                        color: '#111',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em',
                    } }, { children: "Unlock" }))] })) })));
};
export default PasswordAccess;
